export enum GA_EVENT {
	FROM_CLICK = 'from_click',
	FROM_DATA_CLICK = 'from_data_click',
	TO_CLICK = 'to_click',
	TO_DATA_CLICK = 'to_data_click',
	ONE_WAY_CLICK = 'one_way_click',
	ROUND_TRIP_CLICK = 'round_trip_click',
	DATE_CLICK = 'date_click',
	FROM_DATE = 'from_date',
	TO_DATE = 'to_date',
	TRAVELERS_CLICK = 'travelers_click',
	TRAVELERS_SELECT = 'travelers_select',
	CABIN_CLASS_CLICK = 'cabin_class_click',
	CABIN_CLASS_SELECT = 'cabin_class_select',
	SEARCH_WITHOUT_LOCATION = 'search_without_location',
	SEARCH_SUBMISSION = 'search_submission',
	SIGN_UP_ENABLE = 'sign_up_enable',
	FACEBOOK_PIXEL_INIT = 'facebookPixelInit',
	USER_ID = 'user_id',
	SITE_LANGUAGE = 'site_language',
	SEARCH = 'Search',
	HOMEPAGE_VIEW = 'home_page_view',
	BUTTON_CLICK = 'button_click',
}

// Emit straight through the hand-rolled gtag shim (set up in `initializeConsent`,
// which runs before any page renders) rather than `@next/third-parties`
// `sendGAEvent`. That helper silently drops the event unless its <GoogleAnalytics>
// component is mounted — which we no longer render (SF-29). `window.gtag('event', …)`
// pushes the same `['event', name, params]` onto `window.dataLayer`, so every event
// inherits the `user_id` set via `gtag('set', { user_id })`.
export const emitGAEvent = (eventName: GA_EVENT | string, data?: any) => {
	if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
		if (data) {
			window.gtag('event', eventName, data);
		} else {
			window.gtag('event', eventName);
		}
	}
};
export const emitHomePageViewGAEvent = () => emitGAEvent(GA_EVENT.HOMEPAGE_VIEW);
export const emitFromClickGAEvent = () => emitGAEvent(GA_EVENT.FROM_CLICK);
export const emitFromDataClickGAEvent = (data: any) => emitGAEvent(GA_EVENT.FROM_DATA_CLICK, data);
export const emitToClickGAEvent = () => emitGAEvent(GA_EVENT.TO_CLICK);
export const emitToDataClickGAEvent = (data: any) => emitGAEvent(GA_EVENT.TO_DATA_CLICK, data);
export const emitOneWayClickGAEvent = () => emitGAEvent(GA_EVENT.ONE_WAY_CLICK);
export const emitRoundTripClickGAEvent = () => emitGAEvent(GA_EVENT.ROUND_TRIP_CLICK);
export const emitDateClickGAEvent = () => emitGAEvent(GA_EVENT.DATE_CLICK);
export const emitFromDateGAEvent = (data: any) => emitGAEvent(GA_EVENT.FROM_DATE, data);
export const emitToDateGAEvent = (data: any) => emitGAEvent(GA_EVENT.TO_DATE, data);
export const emitTravelersClickGAEvent = () => emitGAEvent(GA_EVENT.TRAVELERS_CLICK);
export const emitTravelersSelectGAEvent = (data: any) => emitGAEvent(GA_EVENT.TRAVELERS_SELECT, data);
export const emitCabinClassClickGAEvent = () => emitGAEvent(GA_EVENT.CABIN_CLASS_CLICK);
export const emitCabinClassSelectGAEvent = (data: any) => emitGAEvent(GA_EVENT.CABIN_CLASS_SELECT, data);
export const emitSearchWithoutLocationGAEvent = (field?: 'from' | 'to' | 'both') =>
	emitGAEvent(GA_EVENT.SEARCH_WITHOUT_LOCATION, field ? { field } : undefined);
export const emitSearchSubmissionGAEvent = (data: any) => emitGAEvent(GA_EVENT.SEARCH_SUBMISSION, data);
export const emitSignUpEnableGAEvent = () => emitGAEvent(GA_EVENT.SIGN_UP_ENABLE);
export const emitFacebookPixelInitGAEvent = (pixelExternalId: string) => emitGAEvent(GA_EVENT.FACEBOOK_PIXEL_INIT, { pixelExternalId });
export const emitUserIdGAEvent = (user_id: string) => emitGAEvent(GA_EVENT.USER_ID, { user_id });
export const emitSiteLanguageGAEvent = (site_language: string) => emitGAEvent(GA_EVENT.SITE_LANGUAGE, { site_language });
export const emitSearchEventGAEvent = (data: any) => emitGAEvent(GA_EVENT.SEARCH, data);

export const emitSearchEventFBEvent = (data: any) => {
	if (typeof window !== 'undefined' && window.fbq) {
		window.fbq('track', 'Search', data);
	}
};
